import React, { useEffect, useState } from "react";
import PaymentsIcon from "@mui/icons-material/Payments";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import EditIcon from "@mui/icons-material/Edit";
import { createData, deleteData } from "../../utility/adminApi";
import ConfirmModal from "../../components/ConfirmModal";
import loader from "../../assets/loader.webp";
import AddPaymentMethod from "./AddPaymentMethod";
import EditPaymentMethod from "./EditPaymentMethod";

function PaymentMethod() {
  const [payMethodData, setPayMethodData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [addtab, setAddtab] = useState(false);
  const [editTab, setEdittab] = useState(false);
  const [formData, setFormData] = useState({});

  const [singleData, setSingleData] = useState({});
  const [methodIdToDelete, setMethodIdToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchPaymentMethods = async () => {
    const response = await createData("payment-methods", {});
    setPayMethodData(response?.data);
    setIsLoading(false);
  };

  const handleAdd = () => {
    setAddtab(true);
    setEdittab(false);
  };
  const handleEditFile = async (item) => {
    setSingleData(item);
    setFormData(item);
    setEdittab(true);
  };

  const handleDelete = (id) => {
    setMethodIdToDelete(id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    const response = await deleteData(
      "payment-methods/delete/",
      methodIdToDelete
    );
    fetchPaymentMethods(); //
    setIsModalOpen(false);
  };
  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  return (
    <div className=" lg:overflow-y-hidden ">
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between  items-center p-4 w-full">
        <h3 className="text-xl font-semibold">
          <PaymentsIcon />
          Payment Method
        </h3>
        <div className="flex gap-6">
          <button
            onClick={() => {
              handleAdd();
            }}
            className="p-3 rounded-lg text-white bg-blue-500"
          >
            Add New Payment Method <AddIcon />
          </button>{" "}
        </div>{" "}
      </div>
      {addtab && !editTab && (
        <AddPaymentMethod
          setIsLoading={setIsLoading}
          setAddtab={setAddtab}
          fetchPaymentMethods={fetchPaymentMethods}
        />
      )}
      {editTab && !addtab && (
        <EditPaymentMethod
          singleData={singleData}
          setSingleData={setSingleData}
          setEdittab={setEdittab}
          formData={formData}
          setFormData={setFormData}
          fetchPaymentMethods={fetchPaymentMethods}
        />
      )}
      {!editTab && !addtab && (
        <div className="w-full p-4 flex flex-col gap-2  bg-white">
          {/* <div>
            <input
              placeholder="Search for"
              type="text"
              name="bill_name"
              // id="email"
              value={searchData}
              onChange={handleChange}
              className="border-2 border-gray-400 w-60 p-2 px-6"
            />
          </div> */}
          <div className="w-full">
            {isLoading ? (
              <div className="  flex justify-center items-center">
                {" "}
                <img
                  src={loader}
                  alt="loader"
                  className=" w-10 lg:w-20 "
                />{" "}
              </div>
            ) : (
              <table className="min-w-full bg-white border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="py-2 px-4 border-b border-gray-300">
                      METHOD
                    </th>

                    <th className="py-2 px-4 border-b border-gray-300 text-wrap">
                      ACTION
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {payMethodData?.map((item) => (
                    <tr
                      key={item?.id}
                      className="hover:bg-gray-100 border-b border-gray-300"
                    >
                      <td className="py-2 px-4 text-wrap text-center">
                        {item?.method_name}
                      </td>

                      <td className="py-2 flex justify-center gap-3 px-2 ">
                        <EditIcon
                          onClick={() => handleEditFile(item)}
                          className="text-blue-500 cursor-pointer"
                        />
                        {/* <VisibilityIcon className="text-yellow-400" /> */}
                        <DeleteIcon
                          onClick={() => handleDelete(item?.id)}
                          className="text-red-500 cursor-pointer"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        text1="Confirm Delete"
        text2="Are you sure you want to delete the bill?"
      />
    </div>
  );
}

export default PaymentMethod;
